import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.js-industries-slider', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: '.section-industries-block__arrow--next',
            prevEl: '.section-industries-block__arrow--prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
});
